import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { loadMessages } from 'devextreme/localization';
import { GeneralCalcSalaryInputsComponent } from 'src/app/pages/hr/general-calc-salary-inputs/general-calc-salary-inputs.component';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { SalaryService } from 'src/app/shared/services/hr/salary.service';

@Component({
  selector: 'app-employee-extra-times',
  templateUrl: './employee-extra-times.component.html',
  styleUrls: ['./employee-extra-times.component.scss']
})
export class EmployeeExtraTimesComponent implements OnInit {

  @ViewChild('dataGridVar', { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('salaryInputs', { static: false }) salaryInputsComponent: GeneralCalcSalaryInputsComponent;

  filterFormData: any = {};
  employeeType = {};
  button = {};
  currentLang: any;
  customDataSource: any = [];
  summuryDataSource: any = [];
  
  // لتتبع التعديلات
  modifiedRows: Map<string, any> = new Map();
  originalData: any[] = [];
  
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";

  constructor(
    public ObjectsService: ObjectsService,
    public SalaryService: SalaryService,
    public gt: genericCustomStoreService,
    public translate: TranslateService
  ) {
    this.button = ObjectsService.button;
    this.currentLang = localStorage.getItem(this.LOCALIZATION_LOCAL_STORAGE_KEY);

    loadMessages({
      en: { 
        "Yes": this.translate.instant('personal.yes'), 
        "No": this.translate.instant('personal.no') 
      }
    });

    gt.getdropdowndata("SharedEnums", "ApprovedStatusDropDown")
      .subscribe((res: []) => this.employeeType = res);
  }

  ngOnInit(): void {
  }

  onFormDataChanged(formData: any): void {
    console.log('Form data changed:', formData);
    this.filterFormData = formData;
  }


loadData(filterData: any): void {
  console.log('=== Loading ExtraTime Data ===');
  console.log('Filter Data to send:', filterData);
  
  this.SalaryService.getEmployeesExtraTimes(filterData).subscribe({
    next: (response: any) => { // ✅ إضافة : any
      console.log('📦 Raw API Response:', response);
      
      // حفظ البيانات الأصلية
      this.originalData = JSON.parse(JSON.stringify(response));
      this.summuryDataSource = response;
      console.log("summuryDataSource", this.summuryDataSource);
      
      let rawData: any[] = []; // ✅ تعريف نوع واضح
      if (response && response.data) {
        rawData = response.data;
      } else if (Array.isArray(response)) {
        rawData = response;
      }
      
      console.log('📊 Raw data count:', rawData.length);

      // Flatten
      this.customDataSource = this.flattenAttendanceData(rawData);
      
      console.log('✅ Custom data source:', this.customDataSource);
      console.log('✅ Total rows to display:', this.customDataSource.length);

      if (this.dataGrid) {
        this.dataGrid.instance.refresh();
        console.log('🔄 Grid refreshed');
      }
      
      // مسح التعديلات السابقة
      this.modifiedRows.clear();
    },
    error: (error) => {
      console.error('❌ API Error:', error);
    }
  });
}
  prepareRequestData(formData: any): any {
    console.log('=== Preparing Request Data ===');
    console.log('Input form data:', formData);
    
    const formatDate = (date: any): string | null => {
      if (!date) {
        console.log('Date is null or undefined');
        return null;
      }
      
      if (date instanceof Date) {
        return date.toISOString();
      }
      
      if (typeof date === 'string') {
        const parsedDate = new Date(date);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toISOString();
        }
      }
      
      return date;
    };
    
    const requestData = {
      FromDate: formatDate(formData.fromDate),
      ToDate: formatDate(formData.toDate),
      RegistrationDate: formatDate(formData.registrationDate),
      exchangeDate: formatDate(formData.exchangeDate),
      EmployeeIds: (formData.employeeIds && formData.employeeIds.length > 0) 
        ? formData.employeeIds 
        : [],
      JobTitleIds: (formData.jobTitleIds && formData.jobTitleIds.length > 0) 
        ? formData.jobTitleIds 
        : [],
      DepartmentIds: (formData.departmentIds && formData.departmentIds.length > 0) 
        ? formData.departmentIds 
        : [],
      WorkSystemIds: (formData.workSystemIds && formData.workSystemIds.length > 0) 
        ? formData.workSystemIds 
        : [],
      ManagementIds: (formData.managementIds && formData.managementIds.length > 0) 
        ? formData.managementIds 
        : [],
      BranchIds: (formData.branchIds && formData.branchIds.length > 0) 
        ? formData.branchIds 
        : [],
      salarytype: formData.salarytype || null,
      bankId: formData.bankId || null,
      salaryNotes: formData.salaryNotes || null
    };
    
    console.log('Final request data:', requestData);
    console.log('=== End Preparing ===');
    
    return requestData;
  }

  resetFilter(): void {
    console.log('=== Reset Filter ===');
    
    if (this.salaryInputsComponent) {
      this.salaryInputsComponent.resetForm();
      this.filterFormData = {};
      this.customDataSource = [];
      this.summuryDataSource = [];
      this.modifiedRows.clear();
      this.originalData = [];
    }
  }

  // ✅ التعامل مع تحديث الصف - معدل للـ extraTimeValue
  updateRow(options: any): void {
    console.log('🔧 Updating row:', options);
    
    const oldValue = options.oldData.extraTimeValue; // ✅ تغيير من delayValue
    const newValue = options.newData.extraTimeValue; // ✅ تغيير من delayValue
    
    if (oldValue !== newValue) {
      const rowId = options.oldData.id;
      const employeeId = options.oldData.employeeId;
      
      this.modifiedRows.set(rowId, {
        ...options.oldData,
        extraTimeValue: newValue, // ✅ تغيير من delayValue
        modified: true
      });
      
      console.log('💾 Modified row saved:', rowId);
      
      // تحديث الـ customDataSource
      const rowIndex = this.customDataSource.findIndex((r: any) => r.id === rowId);
      if (rowIndex !== -1) {
        this.customDataSource[rowIndex].extraTimeValue = newValue; // ✅ تغيير من delayValue
      }
      
      this.recalculateSummary(employeeId);
    }
    
    options.newData.id = options.oldData.id;
  }

  // ✅ إعادة حساب الملخص - معدل للـ extraTimeValues
  recalculateSummary(employeeId: number): void {
    console.log('Recalculating summary for employee:', employeeId);
    
    const employeeRows = this.customDataSource.filter((row: any) => row.employeeId === employeeId);
    const totalExtraTimeValue = employeeRows.reduce((sum: number, row: any) => sum + (row.extraTimeValue || 0), 0); // ✅ تغيير من delayValue
    
    console.log('Total extra time value:', totalExtraTimeValue);
    
    const summaryIndex = this.summuryDataSource.findIndex((s: any) => s.employeeId === employeeId);
    if (summaryIndex !== -1) {
      this.summuryDataSource[summaryIndex].extraTimeValues = totalExtraTimeValue; // ✅ تغيير من delayValues
      console.log('✅ Summary updated for employee:', employeeId);
    }
  }

  refreshGrid(e: boolean): void {
    if (e && this.dataGrid) {
      this.dataGrid.instance.refresh();
    }
  }

  allowUpdating(e: any): boolean {
    return e.row.data.approvedStatus == 1;
  }

  addrowfun(name: string): string {
    return this.gt.addrow(name);
  }
  
  applyFilter(): void {
    console.log('1. salaryInputsComponent:', this.salaryInputsComponent);
    
    const filterData = this.salaryInputsComponent.getFormData();
    console.log('2. filterData:', filterData);
    
    const requestData = this.prepareRequestData(filterData);
    console.log('3. requestData:', requestData);
    
    this.loadData(requestData);
  }

  // ✅ Flatten معدل للـ ExtraTime
  private flattenAttendanceData(data: any[]): any[] {
    console.log('🔄 Starting flatten, input data:', data);
    const flattened: any[] = [];

    data.forEach(employee => {
      console.log('👤 Processing employee:', employee.employeeId, employee.employeeNameAr);
      
      const attendanceArray = employee.attendingandleaving || employee.attendingAndLeaving || [];
      
      console.log('📅 Attendance records count:', attendanceArray.length);
      
      if (attendanceArray && Array.isArray(attendanceArray) && attendanceArray.length > 0) {
        attendanceArray.forEach((att: any, index: number) => {
          const flatRow = {
            id: `${employee.employeeId}_${att.date || index}`,
            employeeId: employee.employeeId,
            employeeName: employee.employeeNameAr || employee.employeeName || `Employee ${employee.employeeId}`,
            workDurationSystemId: att.workDurationSystemId,
            workDurationSystemName: att.workDurationSystemName,
            dateOfDay: att.date,
            timeFrom: att.employeeDurationStartTime,
            timeTo: att.employeeDurationEndTime,
            actualAttend: att.employeeActualAttend || "لم يتم بصم حضور",
            actualLeave: att.employeeActualLeave || "لم يتم بصم انصراف",
            // ✅ الحقول الخاصة بالـ ExtraTime
            attendanceEarly: att.attendanceEarly, // ✅ بدل attendanceLate
            leaveAfterTime: att.leaveAfterTime,   // ✅ بدل leaveEarly
            dayAttendanceTime: att.dayAttendanceTime,
            extraTimeValue: att.extraTimeValue,   // ✅ بدل delayValue
            absenceValue: att.absenceValue,
            isAbsence: att.isAbsence || false,
            approvedStatus: att.approvedStatus || 0,
            permissionDuration: att.permissionDuration
          };
          
          console.log(`  Row ${index + 1}:`, flatRow.dateOfDay, flatRow.extraTimeValue);
          flattened.push(flatRow);
        });
      } else {
        console.warn(`⚠️ No attendance data for employee ${employee.employeeId}`);
      }
    });

    console.log('✅ Flattening complete! Total rows:', flattened.length);
    return flattened;
  }

  // ✅ دالة الحفظ معدلة للـ ExtraTime
  saveExtraTimeData(): void {
    console.log('💾 Starting save process...');
    
    if (this.summuryDataSource.length === 0) {
      alert('لا توجد بيانات للحفظ');
      return;
    }
    
    const dataToSave = this.prepareSaveData();
    console.log('📤 Data to save (Array):', dataToSave);
    
    this.SalaryService.saveEmployeeExtraTimes(dataToSave).subscribe({
      next: (response) => {
        console.log('✅ Save successful:', response);
        alert(`تم الحفظ بنجاح - تم حفظ ${response.savedRows || response} سجل`);
      },
      error: (error) => {
        console.error('❌ Save error:', error);
        alert('حدث خطأ أثناء الحفظ: ' + (error.error?.message || error.message));
      }
    });
  }

  // ✅ تجهيز البيانات للحفظ - معدل للـ ExtraTime
  private prepareSaveData(): any[] {
    const saveData: any[] = [];
    
    this.summuryDataSource.forEach((emp: any) => {
      const employeeAttendance = this.customDataSource.filter(
        (row: any) => row.employeeId === emp.employeeId
      );
      
      const attendingAndLeaving = employeeAttendance.map((row: any) => ({
        EmployeeActualAttend: (row.actualAttend && !row.actualAttend.includes('بصم')) 
          ? row.actualAttend 
          : null,
        EmployeeActualLeave: (row.actualLeave && !row.actualLeave.includes('بصم')) 
          ? row.actualLeave 
          : null,
        EmployeeId: row.employeeId,
        Date: row.dateOfDay,
        ExtraTimeValue: row.extraTimeValue || 0, // ✅ تغيير من DelayValue
        EmployeeDurationEndTime: (row.timeTo && !row.timeTo.includes('بصم')) 
          ? row.timeTo 
          : null,
        EmployeeDurationStartTime: (row.timeFrom && !row.timeFrom.includes('بصم')) 
          ? row.timeFrom 
          : null,
        PermissionDuration: row.permissionDuration || 0,
        WorkDurationSystemId: row.workDurationSystemId || 0,
        WorkDurationSystemName: row.workDurationSystemName || '',
        AttendanceEarly: row.attendanceEarly || "00:00:00", // ✅ بدل AttendanceLate
        LeaveAfterTime: row.leaveAfterTime || "00:00:00",   // ✅ بدل LeaveEarly
        IsAbsence: row.isAbsence || false
      }));
      
      const totalExtraTimeValue = attendingAndLeaving.reduce(
        (sum: any, att: any) => sum + (att.ExtraTimeValue || 0), 
        0
      );
      
      saveData.push({
        EmployeeId: emp.employeeId,
        EmployeeNameAr: emp.employeeNameAr || '',
        ExtraTimeValues: totalExtraTimeValue, // ✅ تغيير من DelayValues
        FromDate: emp.fromDate,
        ToDate: emp.toDate,
        MainSalary: emp.mainSalary || 0,
        SalaryDayValue: emp.salaryDayValue || 0,
        LatnessType: 1, // ✅ تغيير من 0 إلى 1 (ExtraTime)
        ManagementId: emp.managementId,
        IsRate: false,
        Description: `يوم اضافي - ${emp.employeeNameAr}`, // ✅ تغيير من "يوم تأخير"
        Status: 4,
        Attendingandleaving: attendingAndLeaving,
        BranchId: emp.branchId,
        CompanyId: emp.companyId,
        DepartmentId: emp.departmentId,
        WrokSystemtId: emp.wrokSystemtId,
      });
    });
    
    return saveData;
  }

  // ✅ دالة اعتماد الأوقات الإضافية - معدلة
  approveExtraTimeData(): void {
    console.log('✅ Starting approval process...');
    
    if (this.summuryDataSource.length === 0) {
      alert('لا توجد بيانات للاعتماد');
      return;
    }
    
    const dataToApprove = this.prepareApprovalData();
    console.log('📤 Data to approve:', dataToApprove);
    
    this.SalaryService.approveEmployeeExtraTimes(dataToApprove).subscribe({
      next: (response) => {
        console.log('✅ Approval successful:', response);
        alert(`تم الاعتماد بنجاح - تم اعتماد ${response.savedRows || response} سجل`);
      },
      error: (error) => {
        console.error('❌ Approval error:', error);
        alert('حدث خطأ أثناء الاعتماد: ' + (error.error?.message || error.message));
      }
    });
  }

  // ✅ تجهيز البيانات للاعتماد - معدل للـ ExtraTime
  private prepareApprovalData(): any[] {
    const saveData: any[] = [];
    
    const isValidTime = (value: any): boolean => {
      if (!value) return false;
      if (typeof value !== 'string') return false;
      if (value.includes('لم يتم') || value.includes('بصم')) return false;
      return /^\d{2}:\d{2}(:\d{2})?$/.test(value);
    };
    
    this.summuryDataSource.forEach((emp: any) => {
      const employeeAttendance = this.customDataSource.filter(
        (row: any) => row.employeeId === emp.employeeId
      );
      
      const attendingAndLeaving = employeeAttendance.map((row: any) => ({
        EmployeeActualAttend: isValidTime(row.actualAttend) ? row.actualAttend : null,
        EmployeeActualLeave: isValidTime(row.actualLeave) ? row.actualLeave : null,
        EmployeeId: row.employeeId,
        Date: row.dateOfDay,
        ExtraTimeValue: row.extraTimeValue || 0, // ✅ تغيير من DelayValue
        EmployeeDurationEndTime: isValidTime(row.timeTo) ? row.timeTo : null,
        EmployeeDurationStartTime: isValidTime(row.timeFrom) ? row.timeFrom : null,
        PermissionDuration: row.permissionDuration || 0,
        WorkDurationSystemId: row.workDurationSystemId || 0,
        WorkDurationSystemName: row.workDurationSystemName || '',
        AttendanceEarly: row.attendanceEarly || "00:00:00", // ✅ بدل AttendanceLate
        LeaveAfterTime: row.leaveAfterTime || "00:00:00",   // ✅ بدل LeaveEarly
        IsAbsence: row.isAbsence || false
      }));
      
      const totalExtraTimeValue = attendingAndLeaving.reduce(
        (sum: any, att: any) => sum + (att.ExtraTimeValue || 0), 
        0
      );
      
      saveData.push({
        EmployeeId: emp.employeeId,
        EmployeeNameAr: emp.employeeNameAr || '',
        ExtraTimeValues: totalExtraTimeValue, // ✅ تغيير من DelayValues
        FromDate: emp.fromDate,
        ToDate: emp.toDate,
        MainSalary: emp.mainSalary || 0,
        SalaryDayValue: emp.salaryDayValue || 0,
        LatnessType: 1, // ✅ تغيير من 0 إلى 1 (ExtraTime)
        ManagementId: emp.managementId,
        IsRate: false,
        Description: `يوم اضافي - ${emp.employeeNameAr}`, // ✅ تغيير من "يوم تأخير"
        Status: 3, // ✅ Certified
        Attendingandleaving: attendingAndLeaving,
        BranchId: emp.branchId,
        CompanyId: emp.companyId,
        DepartmentId: emp.departmentId,
        WrokSystemtId: emp.wrokSystemtId
      });
    });
    
    return saveData;
  }
}